<template>
  <div>
    <el-card v-if="application.state === 'stopped'" shadow="hover">
      <el-button
        large
        type="primary"
        icon="el-icon-refresh-left"
        @click.prevent="start"
      >
        Start this application
      </el-button>
    </el-card>

    <el-card v-else-if="application.state === 'creating'" shadow="never">
      The creation process has not yet finished ...
    </el-card>

    <el-card v-else shadow="hover">
      <el-row :gutter="15">
        <el-col :span="16">
          <p>The application will no longer be accessible after shutting down.<br>
            But all data remains on the server.</p>
        </el-col>

        <el-col align="right" :span="8">
          <el-button
            large
            type="warning"
            plain
            @click.prevent="shutdown"
          >
            Shutdown
          </el-button>
        </el-col>
      </el-row>
    </el-card>

    <el-alert type="error" show-icon :closable="false">
      <h3 slot="title">Danger Zone</h3>
    </el-alert>

    <el-card class="destroy" shadow="hover">
      <el-row :gutter="15">
        <el-col :span="16">
          <p>Once you destroy an application, there is no going back. Please be certain.</p>
        </el-col>

        <el-col align="right" :span="8">
          <el-button
            large
            type="danger"
            :loading="loading"
            @click.prevent="destroy"
          >
            Destroy this application
          </el-button>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
export default {
  props: {
    application: Object
  },
  data () {
    return {
      loading: false
    }
  },
  methods: {
    destroy () {
      const msg = 'Be careful this action is irreversible. To confirm, please enter "' + this.application.alias + '" below.'
      this.$prompt(msg, 'Are you really sure ?', {
        confirmButtonText: 'Destroy',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        inputValidator: (value) => value === this.application.alias,
        inputErrorMessage: 'Invalid input'
      }).then(() => {
        const instanceId = this.application.instanceId
        this.loading = true
        return this.$store.dispatch('destroyApplication', this.application)
          .then(() => this.$router.push('/instances/' + instanceId))
      }).catch(() => {})
    },
    shutdown () {
      this.$confirm('The application will no longer be accessible. Continue?', 'Shutdown', {
        confirmButtonText: 'Shutdown',
        cancelButtonText: 'Cancel',
        confirmButtonClass: 'el-button--danger',
        type: 'warning'
      }).then(() => {
        return this.$store.dispatch('shutdownApplication', this.application)
          .then(() => this.$router.push('/instances/' + this.application.instanceId))
      }).catch(() => {})
    },
    start () {
      this.$store.dispatch('configApplication', this.application)
        .then(() => this.$router.push('/instances/' + this.application.instanceId + '/' + this.application.id + '/general'))
        .catch(() => {})
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../theme";

  .el-alert {
    margin: 15px 0 -3px;

    h3 {
      margin: 10px 0;
    }
  }

  .el-card.destroy {
    p {
      margin: 10px 0;
    }
  }
</style>
